module.exports = __webpack_public_path__ + "img/food-dish.c5181edb.jpg";